import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import useItemsFetch from "../../hooks/usePlacesSearch";
import BSpinner from "../spinners/BSpinner";
import PropTypes from "prop-types";

export default function BCustomDropdownInput({
  filterBy,
  itemsUrl,
  placeholder,
  fieldName,
  control,
}) {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [selectValue, setSelectValue] = useState({});

  const { loading, options, hasMore } = useItemsFetch(
    itemsUrl,
    query,
    page,
    filterBy
  );

  useEffect(() => {
    setSelectValue(getPreloadedDataFromControl());
  }, [options]);

  const handleSearch = (query) => {
    setQuery(query);
    setPage(1);
  };

  const setNextPage = () => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handleInputChange = (e) => {
    if (e == null) {
      return null;
    }

    setSelectValue(e);
    return e.value;
  };

  const getPreloadedDataFromControl = () => {
    if (
      !options ||
      !control.defaultValuesRef ||
      !control.defaultValuesRef.current[`${fieldName}`]
    ) {
      return;
    }
    
    const loadedData = control.defaultValuesRef.current[`${fieldName}`];

    const dataFromOptions = options.find((o) => o.value === loadedData);

    if (!dataFromOptions) {
      setNextPage();
      return;
    }

    return dataFromOptions;
  };

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        render={({ field: { onChange } }) => (
          <Select
            onChange={(e) => onChange(handleInputChange(e))}
            isLoading={loading}
            onInputChange={(e) => handleSearch(e)}
            placeholder={placeholder}
            options={options}
            onMenuScrollToBottom={setNextPage}
            loadingMessage={() => <BSpinner />}
            noOptionsMessage={() =>
              `No one ${fieldName} match to serach phrase.`
            }
            value={selectValue}
          />
        )}
        rules={{ required: true }}
      />
    </>
  );
}

BCustomDropdownInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  control: PropTypes.object.isRequired,
  itemsUrl: PropTypes.string.isRequired,
  filterBy: PropTypes.string.isRequired,
};
